export const environment = {
  production: false,
  projectName: "LunaFilataDemo",
  dev: {
    REST_API_SERVER: "https://lunafilata.api.demo.testctsolution.it/api"
  },
  variables: {
    defaults: {}
  },
  customTranslationsDirectory: '/assets/custom-translations',
  defaultLang: 'it'
};
